import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { identityConstants } from './identity-constants';

@Injectable({ providedIn: 'root' })
export class IdentityStore {

    tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(localStorage.getItem(identityConstants.token));
    refreshTokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(localStorage.getItem(identityConstants.refreshToken));
    permissionsSubject: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(getPermissions());

    constructor() {
        this.tokenSubject.pipe(
            tap(token => {
                // debugger;
                if (token) {

                    localStorage.setItem(identityConstants.token, token);
                }
                else {

                    localStorage.removeItem(identityConstants.token)
                }

            })
        ).subscribe();

        this.permissionsSubject.pipe(
            tap(permissions => {
                if (permissions) {
                    localStorage.setItem(identityConstants.permissions, JSON.stringify(permissions));
                }
                else {
                    localStorage.removeItem(identityConstants.permissions);
                }

            })
        ).subscribe();

        this.refreshTokenSubject.pipe(
            tap(refreshToken => {
                if (refreshToken) {
                    localStorage.setItem(identityConstants.refreshToken, refreshToken);
                }
                else {
                    localStorage.removeItem(identityConstants.refreshToken);
                }
            })
        ).subscribe();

        // this.token = localStorage.getItem(identityConstants.token);
        // this.refreshToken = localStorage.getItem(identityConstants.refreshToken);
        // this.permissions = getPermissions();
    }

    get token() {
        return this.tokenSubject.value;
    }
    set token(_: string) {
        this.tokenSubject.next(_);
    }

    get refreshToken() {
        return this.refreshTokenSubject.value;
    }
    set refreshToken(_: string) {
        this.refreshTokenSubject.next(_);
    }

    get permissions() {
        return this.permissionsSubject.value;
    }
    set permissions(_: string[]) {
        this.permissionsSubject.next(_)
    }



    clear() {


        // debugger;
        this.token = undefined;
        this.refreshToken = undefined;
        this.permissions = undefined;
    }

}

function getPermissions() {
    var json = localStorage.getItem("permissions");
    if (!json || json === 'undefined') return [];
    return JSON.parse(json) as string[];
}
